export const listMutations = <const>{
	PRACOVNI_POZICE_TABULKOVA_POZICE_FILTER_SELECT_MAPPER: 'PRACOVNI_POZICE_TABULKOVA_POZICE_FILTER_SELECT_MAPPER',
	PRACOVNI_POZICE_PP_NR_FILTER_SELECT_MAPPER: 'PRACOVNI_POZICE_PP_NR_FILTER_SELECT_MAPPER',
};

export const editMutations = <const>{
	PRACOVNI_POZICE_TABULKOVA_POZICE_SELECT_MAPPER: 'PRACOVNI_POZICE_TABULKOVA_POZICE_SELECT_MAPPER',
};

export enum PpFilterEnum {
	Default = 0,
	Sda,
	Sp,
	Nekoncernove,
	VolneNekoncernove
}
